export default __webpack_public_path__ + "static/media/Report.d4301953.svg";